// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- CSS VARIABLES & RESET --- */
:root {
  --bg-color: #050505;
  --text-color: #ffffff;
  --accent-dim: #444444;
  --accent-bright: #e0e0e0;
  --primary-accent: #00ADB5;
  --font-main: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  --font-mono: 'Courier New', Courier, monospace;
  --nav-height: 76px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: var(--bg-color);
  color: var(--text-color);
  font-family: var(--font-main);
  overflow: hidden; /* Body never scrolls — ui-layer scrolls internally */
  width: 100vw;
  height: 100vh;
}

.App {
  position: relative;
  width: 100%;
  height: 100%;
}

/* --- CANVAS (always fixed behind everything) --- */
#canvas-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* ============================================================
   UI LAYER — the scrollable container over the canvas
   ============================================================ */
.ui-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

/* Thin custom scrollbar */
.ui-layer::-webkit-scrollbar { width: 2px; }
.ui-layer::-webkit-scrollbar-track { background: transparent; }
.ui-layer::-webkit-scrollbar-thumb { background: var(--accent-dim); }

/* ============================================================
   PAGE-DOT INDICATOR (fixed, right side)
   ============================================================ */
.page-dots {
  position: fixed;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  z-index: 100;
  pointer-events: auto;
}

.page-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  border: 1px solid var(--accent-dim);
  background: transparent;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
}

.page-dot.active {
  background: var(--primary-accent);
  border-color: var(--primary-accent);
  transform: scale(1.5);
}

/* ============================================================
   NAVIGATION — sticky inside the scroll container
   ============================================================ */
nav {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--accent-dim);
  padding: 1.5rem 4rem;
  pointer-events: auto;
  flex-shrink: 0;
  background: rgba(5, 5, 5, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.05em;
  text-transform: uppercase;
}

.nav-links a {
  color: var(--text-color);
  text-decoration: none;
  margin-left: 2rem;
  font-size: 0.9rem;
  font-family: var(--font-mono);
  opacity: 0.7;
  transition: opacity 0.3s;
}

.nav-links a:hover {
  opacity: 1;
  color: var(--primary-accent);
}

/* Nav CTA */
.nav-cta {
  display: inline-block;
  background: transparent;
  color: var(--primary-accent) !important;
  border: 1px solid var(--primary-accent);
  padding: 0.4rem 1rem;
  font-family: var(--font-mono);
  font-size: 0.8rem !important;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 1 !important;
}

.nav-cta:hover {
  background: var(--primary-accent) !important;
  color: var(--bg-color) !important;
}

/* ============================================================
   PAGE 1 — HERO SECTION
   ============================================================ */
.hero-section {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 4rem 4rem;
  pointer-events: auto;
  position: relative;
}

.hero {
  max-width: 640px;
}

.label {
  font-family: var(--font-mono);
  color: var(--accent-dim);
  margin-bottom: 1rem;
  font-size: 0.85rem;
  letter-spacing: 0.1em;
}

.label::before {
  content: ">> ";
}

.hero h1 {
  font-size: 4.5rem;
  line-height: 1;
  font-weight: 300;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
  text-align: left;
}

.hero h1 span {
  font-weight: 700;
}

.hero p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #aaa;
  margin-bottom: 2.5rem;
  border-left: 2px solid var(--accent-dim);
  padding-left: 1.5rem;
  text-align: left;
}

/* Dual CTA buttons */
.hero-cta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}

/* Scroll hint at bottom of hero */
.scroll-hint {
  position: absolute;
  bottom: 2.5rem;
  left: 4rem;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--accent-dim);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  animation: pulseHint 2.5s ease-in-out infinite;
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.scroll-hint::before {
  content: "";
  display: inline-block;
  width: 1px;
  height: 28px;
  background: var(--accent-dim);
  animation: growLine 2.5s ease-in-out infinite;
}

@keyframes pulseHint {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.9; }
}

@keyframes growLine {
  0%, 100% { height: 20px; }
  50% { height: 32px; }
}

/* ============================================================
   CTA BUTTONS
   ============================================================ */
.btn {
  display: inline-block;
  background: transparent;
  color: var(--text-color);
  border: 1px solid var(--text-color);
  padding: 1rem 2rem;
  font-family: var(--font-mono);
  font-size: 0.9rem;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
}

.btn:hover {
  background: var(--text-color);
  color: var(--bg-color);
}

.btn-primary {
  border-color: var(--primary-accent);
  color: var(--primary-accent);
}

.btn-primary:hover {
  background: var(--primary-accent);
  color: var(--bg-color);
}

.btn-secondary {
  border-color: rgba(255, 255, 255, 0.35);
  color: rgba(255, 255, 255, 0.55);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--text-color);
}

/* ============================================================
   PAGE 2 — SERVICES SECTION
   ============================================================ */
.services-section {
  padding: 5rem 4rem 4rem;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.45);
  position: relative;
}

.section-header {
  margin-bottom: 3.5rem;
}

.section-header h2 {
  font-size: 2.8rem;
  font-weight: 300;
  letter-spacing: -0.02em;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.section-header h2 span {
  font-weight: 700;
}

.section-header .section-intro {
  font-size: 1rem;
  color: #888;
  max-width: 560px;
  line-height: 1.7;
  border: none;
  padding: 0;
  margin: 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  max-width: 1100px;
}

.service-card {
  border: 1px solid var(--accent-dim);
  padding: 0;
  transition: border-color 0.35s ease;
  background: rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.service-card:hover {
  border-color: var(--primary-accent);
}

.service-card-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.service-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(80%) brightness(0.55);
  transition: filter 0.45s ease, transform 0.45s ease;
  display: block;
}

.service-card:hover .service-card-image img {
  filter: grayscale(20%) brightness(0.75);
  transform: scale(1.04);
}

.service-card-body {
  padding: 1.5rem;
}

.service-tag {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: var(--primary-accent);
  letter-spacing: 0.18em;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.service-card h3 {
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 0.75rem;
  color: var(--text-color);
  letter-spacing: -0.01em;
}

.service-card p {
  font-size: 0.88rem;
  color: #888;
  line-height: 1.65;
  border: none;
  padding: 0;
  margin: 0;
}

/* ============================================================
   PAGE 3 — CONSULTATION SECTION
   ============================================================ */
.consult-section {
  padding: 5rem 4rem 5rem;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: rgba(0, 0, 0, 0.35);
}

.consult-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4.5rem;
  align-items: center;
  max-width: 1100px;
  margin-top: 3rem;
}

.consult-text p {
  font-size: 0.98rem;
  line-height: 1.85;
  color: #aaa;
  border: none;
  padding: 0;
  margin-bottom: 1.25rem;
}

.consult-text p:last-child {
  margin-bottom: 0;
}

.consult-cta {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  align-items: flex-start;
}

.consult-cta-note {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--accent-dim);
  letter-spacing: 0.05em;
}

.consult-image {
  border: 1px solid var(--accent-dim);
  overflow: hidden;
  transition: border-color 0.35s ease;
}

.consult-image:hover {
  border-color: var(--primary-accent);
}

.consult-image img {
  width: 100%;
  height: 440px;
  object-fit: cover;
  filter: grayscale(65%) brightness(0.6);
  display: block;
  transition: filter 0.45s ease, transform 0.45s ease;
}

.consult-image:hover img {
  filter: grayscale(20%) brightness(0.85);
  transform: scale(1.03);
}

/* ============================================================
   FOOTER / STATS
   ============================================================ */
.stats {
  display: flex;
  gap: 4rem;
  border-top: 1px solid var(--accent-dim);
  padding: 1.5rem 4rem;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  pointer-events: auto;
  flex-shrink: 0;
  background: rgba(5, 5, 5, 0.65);
  backdrop-filter: blur(6px);
}

.stat-item span {
  display: block;
  color: var(--accent-dim);
  margin-bottom: 0.2rem;
}

/* ============================================================
   MODALS & OVERLAYS
   ============================================================ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(5, 5, 5, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: #111;
  border: 1px solid var(--accent-dim);
  border-radius: 0;
  padding: 30px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
  color: var(--text-color);
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--accent-dim);
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  transition: color 0.3s ease;
}

.modal-close:hover {
  color: var(--primary-accent);
}

.modal-image-container {
  margin-bottom: 20px;
  text-align: center;
}

.modal-image {
  max-width: 100%;
  height: auto;
  border: 1px solid var(--accent-dim);
}

.modal-title {
  font-family: var(--font-mono);
  font-size: 1.8em;
  margin-bottom: 15px;
  color: var(--text-color);
  text-align: left;
  border-bottom: 1px solid var(--accent-dim);
  padding-bottom: 10px;
}

.modal-description {
  line-height: 1.6;
  margin-bottom: 25px;
  text-align: left;
  color: #ccc;
}

.modal-actions {
  text-align: right;
  margin-top: 20px;
}

.modal-visit-btn {
  background-color: transparent;
  color: var(--primary-accent);
  border: 1px solid var(--primary-accent);
  padding: 10px 24px;
  border-radius: 0;
  font-size: 14px;
  font-family: var(--font-mono);
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
}

.modal-visit-btn:hover {
  background-color: var(--primary-accent);
  color: #000;
}

/* ============================================================
   PROJECTS GRID
   ============================================================ */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.project-card {
  display: flex;
  flex-direction: column;
  background: #111;
  border: 1px solid var(--accent-dim);
  padding: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.project-card:hover {
  border-color: var(--primary-accent);
  transform: translateY(-2px);
}

.project-image img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
  filter: grayscale(100%);
  transition: filter 0.3s ease;
}

.project-card:hover .project-image img {
  filter: grayscale(0%);
}

.project-card h3 {
  font-family: var(--font-mono);
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: var(--text-color);
}

.project-card p {
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 15px;
  border-left: none;
  padding-left: 0;
  line-height: 1.4;
}

.project-card .btn.learn-more {
  margin-top: auto;
  align-self: flex-start;
  padding: 5px 10px;
  font-size: 0.8rem;
  border-color: var(--accent-dim);
}

/* ============================================================
   FORMS (Contact + Consultation)
   ============================================================ */
.form-group {
  margin-bottom: 0;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  background-color: #000;
  border: 1px solid var(--accent-dim);
  color: var(--text-color);
  font-family: var(--font-mono);
  font-size: 14px;
  margin-bottom: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-accent);
}

/* Radio group for consultation */
.form-radio-group {
  display: flex;
  gap: 2rem;
  margin-bottom: 16px;
}

.form-radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-mono);
  font-size: 0.88rem;
  cursor: pointer;
  color: #aaa;
  transition: color 0.2s;
}

.form-radio-option:hover {
  color: var(--text-color);
}

.form-radio-option input[type="radio"] {
  accent-color: var(--primary-accent);
  width: 15px;
  height: 15px;
  margin: 0;
  cursor: pointer;
}

.form-label {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--accent-dim);
  letter-spacing: 0.12em;
  margin-bottom: 8px;
  text-transform: uppercase;
  display: block;
}

/* ============================================================
   RESPONSIVE — MOBILE FIRST ADJUSTMENTS
   ============================================================ */
@media (max-width: 768px) {

  nav {
    padding: 1.25rem 1.5rem;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .nav-links {
    display: flex;
    gap: 0.5rem;
  }

  .nav-links a {
    margin-left: 0;
    margin-right: 0;
    font-size: 0.82rem;
  }

  /* Hero */
  .hero-section {
    min-height: 100vh;
    padding: 3rem 1.5rem 5rem;
    justify-content: flex-end;
  }

  .hero h1 {
    font-size: 2.8rem;
  }

  .hero p {
    font-size: 0.95rem;
  }

  .hero-cta {
    flex-direction: column;
    align-items: flex-start;
  }

  .scroll-hint {
    left: 1.5rem;
    bottom: 2rem;
  }

  /* Services */
  .services-section {
    padding: 4rem 1.5rem;
    min-height: auto;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  /* Consultation */
  .consult-section {
    padding: 4rem 1.5rem 4rem;
    min-height: auto;
    justify-content: flex-start;
  }

  .consult-content {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    margin-top: 2rem;
  }

  .consult-image img {
    height: 220px;
  }

  /* Footer */
  .stats {
    flex-wrap: wrap;
    gap: 1.5rem;
    padding: 1.25rem 1.5rem;
  }

  /* Page dots */
  .page-dots {
    right: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,2DAA2D;EAC3D,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB,EAAE,qDAAqD;EACvE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,6BAA6B,EAAE;;AAEpE;;iEAEiE;AACjE;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;EACvC,uCAAuC;EACvC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;;iEAEiE;AACjE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;;iEAEiE;AACjE;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;;iEAEiE;AACjE;EACE,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,UAAU;EACV,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;;iEAEiE;AACjE;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,uCAAuC;EACvC,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;;EAEE;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA,SAAS;EACT;IACE,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA,aAAa;EACb;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,WAAW;EACX;IACE,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA,cAAc;EACd;IACE,cAAc;EAChB;AACF","sourcesContent":["/* --- CSS VARIABLES & RESET --- */\n:root {\n  --bg-color: #050505;\n  --text-color: #ffffff;\n  --accent-dim: #444444;\n  --accent-bright: #e0e0e0;\n  --primary-accent: #00ADB5;\n  --font-main: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  --font-mono: 'Courier New', Courier, monospace;\n  --nav-height: 76px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: var(--bg-color);\n  color: var(--text-color);\n  font-family: var(--font-main);\n  overflow: hidden; /* Body never scrolls — ui-layer scrolls internally */\n  width: 100vw;\n  height: 100vh;\n}\n\n.App {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* --- CANVAS (always fixed behind everything) --- */\n#canvas-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n/* ============================================================\n   UI LAYER — the scrollable container over the canvas\n   ============================================================ */\n.ui-layer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n}\n\n/* Thin custom scrollbar */\n.ui-layer::-webkit-scrollbar { width: 2px; }\n.ui-layer::-webkit-scrollbar-track { background: transparent; }\n.ui-layer::-webkit-scrollbar-thumb { background: var(--accent-dim); }\n\n/* ============================================================\n   PAGE-DOT INDICATOR (fixed, right side)\n   ============================================================ */\n.page-dots {\n  position: fixed;\n  right: 1.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  z-index: 100;\n  pointer-events: auto;\n}\n\n.page-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  border: 1px solid var(--accent-dim);\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.3s ease, border-color 0.3s ease;\n}\n\n.page-dot.active {\n  background: var(--primary-accent);\n  border-color: var(--primary-accent);\n  transform: scale(1.5);\n}\n\n/* ============================================================\n   NAVIGATION — sticky inside the scroll container\n   ============================================================ */\nnav {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--accent-dim);\n  padding: 1.5rem 4rem;\n  pointer-events: auto;\n  flex-shrink: 0;\n  background: rgba(5, 5, 5, 0.75);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  text-transform: uppercase;\n}\n\n.nav-links a {\n  color: var(--text-color);\n  text-decoration: none;\n  margin-left: 2rem;\n  font-size: 0.9rem;\n  font-family: var(--font-mono);\n  opacity: 0.7;\n  transition: opacity 0.3s;\n}\n\n.nav-links a:hover {\n  opacity: 1;\n  color: var(--primary-accent);\n}\n\n/* Nav CTA */\n.nav-cta {\n  display: inline-block;\n  background: transparent;\n  color: var(--primary-accent) !important;\n  border: 1px solid var(--primary-accent);\n  padding: 0.4rem 1rem;\n  font-family: var(--font-mono);\n  font-size: 0.8rem !important;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  opacity: 1 !important;\n}\n\n.nav-cta:hover {\n  background: var(--primary-accent) !important;\n  color: var(--bg-color) !important;\n}\n\n/* ============================================================\n   PAGE 1 — HERO SECTION\n   ============================================================ */\n.hero-section {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 5rem 4rem 4rem;\n  pointer-events: auto;\n  position: relative;\n}\n\n.hero {\n  max-width: 640px;\n}\n\n.label {\n  font-family: var(--font-mono);\n  color: var(--accent-dim);\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  letter-spacing: 0.1em;\n}\n\n.label::before {\n  content: \">> \";\n}\n\n.hero h1 {\n  font-size: 4.5rem;\n  line-height: 1;\n  font-weight: 300;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.03em;\n  text-align: left;\n}\n\n.hero h1 span {\n  font-weight: 700;\n}\n\n.hero p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: #aaa;\n  margin-bottom: 2.5rem;\n  border-left: 2px solid var(--accent-dim);\n  padding-left: 1.5rem;\n  text-align: left;\n}\n\n/* Dual CTA buttons */\n.hero-cta {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* Scroll hint at bottom of hero */\n.scroll-hint {\n  position: absolute;\n  bottom: 2.5rem;\n  left: 4rem;\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--accent-dim);\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  animation: pulseHint 2.5s ease-in-out infinite;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.scroll-hint::before {\n  content: \"\";\n  display: inline-block;\n  width: 1px;\n  height: 28px;\n  background: var(--accent-dim);\n  animation: growLine 2.5s ease-in-out infinite;\n}\n\n@keyframes pulseHint {\n  0%, 100% { opacity: 0.3; }\n  50% { opacity: 0.9; }\n}\n\n@keyframes growLine {\n  0%, 100% { height: 20px; }\n  50% { height: 32px; }\n}\n\n/* ============================================================\n   CTA BUTTONS\n   ============================================================ */\n.btn {\n  display: inline-block;\n  background: transparent;\n  color: var(--text-color);\n  border: 1px solid var(--text-color);\n  padding: 1rem 2rem;\n  font-family: var(--font-mono);\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: fit-content;\n}\n\n.btn:hover {\n  background: var(--text-color);\n  color: var(--bg-color);\n}\n\n.btn-primary {\n  border-color: var(--primary-accent);\n  color: var(--primary-accent);\n}\n\n.btn-primary:hover {\n  background: var(--primary-accent);\n  color: var(--bg-color);\n}\n\n.btn-secondary {\n  border-color: rgba(255, 255, 255, 0.35);\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--text-color);\n}\n\n/* ============================================================\n   PAGE 2 — SERVICES SECTION\n   ============================================================ */\n.services-section {\n  padding: 5rem 4rem 4rem;\n  pointer-events: auto;\n  background: rgba(0, 0, 0, 0.45);\n  position: relative;\n}\n\n.section-header {\n  margin-bottom: 3.5rem;\n}\n\n.section-header h2 {\n  font-size: 2.8rem;\n  font-weight: 300;\n  letter-spacing: -0.02em;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.section-header h2 span {\n  font-weight: 700;\n}\n\n.section-header .section-intro {\n  font-size: 1rem;\n  color: #888;\n  max-width: 560px;\n  line-height: 1.7;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  max-width: 1100px;\n}\n\n.service-card {\n  border: 1px solid var(--accent-dim);\n  padding: 0;\n  transition: border-color 0.35s ease;\n  background: rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.service-card:hover {\n  border-color: var(--primary-accent);\n}\n\n.service-card-image {\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n}\n\n.service-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(80%) brightness(0.55);\n  transition: filter 0.45s ease, transform 0.45s ease;\n  display: block;\n}\n\n.service-card:hover .service-card-image img {\n  filter: grayscale(20%) brightness(0.75);\n  transform: scale(1.04);\n}\n\n.service-card-body {\n  padding: 1.5rem;\n}\n\n.service-tag {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  color: var(--primary-accent);\n  letter-spacing: 0.18em;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n}\n\n.service-card h3 {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 0.75rem;\n  color: var(--text-color);\n  letter-spacing: -0.01em;\n}\n\n.service-card p {\n  font-size: 0.88rem;\n  color: #888;\n  line-height: 1.65;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* ============================================================\n   PAGE 3 — CONSULTATION SECTION\n   ============================================================ */\n.consult-section {\n  padding: 5rem 4rem 5rem;\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.consult-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4.5rem;\n  align-items: center;\n  max-width: 1100px;\n  margin-top: 3rem;\n}\n\n.consult-text p {\n  font-size: 0.98rem;\n  line-height: 1.85;\n  color: #aaa;\n  border: none;\n  padding: 0;\n  margin-bottom: 1.25rem;\n}\n\n.consult-text p:last-child {\n  margin-bottom: 0;\n}\n\n.consult-cta {\n  margin-top: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  align-items: flex-start;\n}\n\n.consult-cta-note {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  color: var(--accent-dim);\n  letter-spacing: 0.05em;\n}\n\n.consult-image {\n  border: 1px solid var(--accent-dim);\n  overflow: hidden;\n  transition: border-color 0.35s ease;\n}\n\n.consult-image:hover {\n  border-color: var(--primary-accent);\n}\n\n.consult-image img {\n  width: 100%;\n  height: 440px;\n  object-fit: cover;\n  filter: grayscale(65%) brightness(0.6);\n  display: block;\n  transition: filter 0.45s ease, transform 0.45s ease;\n}\n\n.consult-image:hover img {\n  filter: grayscale(20%) brightness(0.85);\n  transform: scale(1.03);\n}\n\n/* ============================================================\n   FOOTER / STATS\n   ============================================================ */\n.stats {\n  display: flex;\n  gap: 4rem;\n  border-top: 1px solid var(--accent-dim);\n  padding: 1.5rem 4rem;\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  pointer-events: auto;\n  flex-shrink: 0;\n  background: rgba(5, 5, 5, 0.65);\n  backdrop-filter: blur(6px);\n}\n\n.stat-item span {\n  display: block;\n  color: var(--accent-dim);\n  margin-bottom: 0.2rem;\n}\n\n/* ============================================================\n   MODALS & OVERLAYS\n   ============================================================ */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(5, 5, 5, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(5px);\n}\n\n.modal-content {\n  background: #111;\n  border: 1px solid var(--accent-dim);\n  border-radius: 0;\n  padding: 30px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);\n  color: var(--text-color);\n}\n\n.modal-close {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--accent-dim);\n  cursor: pointer;\n  padding: 5px;\n  line-height: 1;\n  transition: color 0.3s ease;\n}\n\n.modal-close:hover {\n  color: var(--primary-accent);\n}\n\n.modal-image-container {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.modal-image {\n  max-width: 100%;\n  height: auto;\n  border: 1px solid var(--accent-dim);\n}\n\n.modal-title {\n  font-family: var(--font-mono);\n  font-size: 1.8em;\n  margin-bottom: 15px;\n  color: var(--text-color);\n  text-align: left;\n  border-bottom: 1px solid var(--accent-dim);\n  padding-bottom: 10px;\n}\n\n.modal-description {\n  line-height: 1.6;\n  margin-bottom: 25px;\n  text-align: left;\n  color: #ccc;\n}\n\n.modal-actions {\n  text-align: right;\n  margin-top: 20px;\n}\n\n.modal-visit-btn {\n  background-color: transparent;\n  color: var(--primary-accent);\n  border: 1px solid var(--primary-accent);\n  padding: 10px 24px;\n  border-radius: 0;\n  font-size: 14px;\n  font-family: var(--font-mono);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n}\n\n.modal-visit-btn:hover {\n  background-color: var(--primary-accent);\n  color: #000;\n}\n\n/* ============================================================\n   PROJECTS GRID\n   ============================================================ */\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 20px 0;\n}\n\n.project-card {\n  display: flex;\n  flex-direction: column;\n  background: #111;\n  border: 1px solid var(--accent-dim);\n  padding: 20px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.project-card:hover {\n  border-color: var(--primary-accent);\n  transform: translateY(-2px);\n}\n\n.project-image img {\n  width: 100%;\n  height: auto;\n  margin-bottom: 15px;\n  filter: grayscale(100%);\n  transition: filter 0.3s ease;\n}\n\n.project-card:hover .project-image img {\n  filter: grayscale(0%);\n}\n\n.project-card h3 {\n  font-family: var(--font-mono);\n  font-size: 1.1rem;\n  margin-bottom: 10px;\n  color: var(--text-color);\n}\n\n.project-card p {\n  font-size: 0.9rem;\n  color: #888;\n  margin-bottom: 15px;\n  border-left: none;\n  padding-left: 0;\n  line-height: 1.4;\n}\n\n.project-card .btn.learn-more {\n  margin-top: auto;\n  align-self: flex-start;\n  padding: 5px 10px;\n  font-size: 0.8rem;\n  border-color: var(--accent-dim);\n}\n\n/* ============================================================\n   FORMS (Contact + Consultation)\n   ============================================================ */\n.form-group {\n  margin-bottom: 0;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  background-color: #000;\n  border: 1px solid var(--accent-dim);\n  color: var(--text-color);\n  font-family: var(--font-mono);\n  font-size: 14px;\n  margin-bottom: 16px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-accent);\n}\n\n/* Radio group for consultation */\n.form-radio-group {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 16px;\n}\n\n.form-radio-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: var(--font-mono);\n  font-size: 0.88rem;\n  cursor: pointer;\n  color: #aaa;\n  transition: color 0.2s;\n}\n\n.form-radio-option:hover {\n  color: var(--text-color);\n}\n\n.form-radio-option input[type=\"radio\"] {\n  accent-color: var(--primary-accent);\n  width: 15px;\n  height: 15px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.form-label {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  color: var(--accent-dim);\n  letter-spacing: 0.12em;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  display: block;\n}\n\n/* ============================================================\n   RESPONSIVE — MOBILE FIRST ADJUSTMENTS\n   ============================================================ */\n@media (max-width: 768px) {\n\n  nav {\n    padding: 1.25rem 1.5rem;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .nav-links {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n  .nav-links a {\n    margin-left: 0;\n    margin-right: 0;\n    font-size: 0.82rem;\n  }\n\n  /* Hero */\n  .hero-section {\n    min-height: 100vh;\n    padding: 3rem 1.5rem 5rem;\n    justify-content: flex-end;\n  }\n\n  .hero h1 {\n    font-size: 2.8rem;\n  }\n\n  .hero p {\n    font-size: 0.95rem;\n  }\n\n  .hero-cta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .scroll-hint {\n    left: 1.5rem;\n    bottom: 2rem;\n  }\n\n  /* Services */\n  .services-section {\n    padding: 4rem 1.5rem;\n    min-height: auto;\n  }\n\n  .section-header h2 {\n    font-size: 2rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Consultation */\n  .consult-section {\n    padding: 4rem 1.5rem 4rem;\n    min-height: auto;\n    justify-content: flex-start;\n  }\n\n  .consult-content {\n    grid-template-columns: 1fr;\n    gap: 2.5rem;\n    margin-top: 2rem;\n  }\n\n  .consult-image img {\n    height: 220px;\n  }\n\n  /* Footer */\n  .stats {\n    flex-wrap: wrap;\n    gap: 1.5rem;\n    padding: 1.25rem 1.5rem;\n  }\n\n  /* Page dots */\n  .page-dots {\n    right: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
